import { Paper, type PaperProps, useTheme } from "@mui/material";

interface BlockProps extends PaperProps {
  flushOnMobile?: boolean;
}

export default function Block({ children, sx, flushOnMobile, ...props }: BlockProps) {
  const theme = useTheme();

  return (
    <Paper
      {...props}
      sx={{
        p: 3,
        borderRadius: 5,
        border: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
        overflow: "hidden",
        ...(flushOnMobile && {
          [theme.breakpoints.only("xs")]: {
            border: 0,
            borderRadius: 0,
            py: 0,
            px: 1,
            backgroundColor: "transparent",
          },
        }),
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
}
